module.exports = __webpack_public_path__ + "static/staw-53de5061849b505945324ffb68a15bb9.jpg";